import { render, staticRenderFns } from "./shipmentsTable.vue?vue&type=template&id=386f681a&scoped=true&"
import script from "./shipmentsTable.vue?vue&type=script&lang=js&"
export * from "./shipmentsTable.vue?vue&type=script&lang=js&"
import style0 from "./shipmentsTable.vue?vue&type=style&index=0&id=386f681a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "386f681a",
  null
  
)

export default component.exports